function withDefaults(component, defaultProps) {
    component.defaultProps = defaultProps;
    return component;
}
export default withDefaults;
//# sourceMappingURL=with-defaults.js.map